import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Tabs,
  Tab,
  Typography,
  Box,
  Button,
  Paper,
  IconButton,
  TextField,
  Menu,
  MenuItem,
  Avatar,
  ListItemIcon,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Divider,
  Pagination,
  TableContainer,
  TableHead,
  TableRow,
  Table,
  TableCell,
  TableBody,
  Skeleton,
  Tooltip,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SortIcon from "@mui/icons-material/ArrowDropDown";
import PersonIcon from "@mui/icons-material/Person";
import GroupAddIcon from "@mui/icons-material/GroupAdd";
import CloseIcon from "../../assets/images/closeIcon.png";
// import DeleteIcon from "@mui/icons-material/Delete";
import "./ListPage.scss";
import AddNoteDialog from "../AddNotes";
import StakeHoldersDetail from "../StakeHoldersDetail";
import {
  CreateStakemap,
  GetStakemapDetail,
  UpdateStakemap,
} from "../../service/StakemapService";
import { PreferencesContext } from "../../PreferenceContext";
import { AlertType } from "../../shared/AlertType";
import {
  CreateStake,
  DeleteStake,
  GetStakeList,
  UpdateStake,
} from "../../service/StakeService";
import AccountCircleSharpIcon from "@mui/icons-material/AccountCircleSharp";
import AddStakeHolderDialog from "../AddStakeHolder";
import { GetTempTypeList } from "../../service/TemperatureTypeService";
import Editicon from "../../assets/images/editicon.png";
import Detailicon from "../../assets/images/detailicon.png";
import NoteIcon from "../../assets/images/note.png";
import editProfileIcon from "../../assets/images/editprofile.png";
import zoomIcon from "../../assets/images/zoomIcon.png";
import SearchIcon from "../../assets/icons/search-icon.svg";
import CustomPagination from "../CustomPagination";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import AddIcon from "../../assets/images/AddIcon.png";
import EditStakeIcon from "../../assets/images/editStakeIcon.png";
import moreIcon from "../../assets/images/moreIcon.png";
import DuplicateIcon from "../../assets/images/duplicateIcon.png";
import DeleteIcon from "../../assets/images/deleteIcon.png";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { PAGE_SIZE } from "../../service/common/const";
import Arrow from "../../assets/images/arrow.png";
import ListTopSection from "./ListTopSection";
import CustomTooltip from "../CustomTooltip";

const ListPage = ({
  title,
  setTitle,
  handleSave,
}: {
  title: string;
  setTitle: (val: string) => void;
  handleSave: () => void;
}) => {
  const { userContext, updateUserContext } = useContext(PreferencesContext);
  //  const [title, setTitle] = useState("Untitled Stake");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedStakeholder, setSelectedStakeholder] = useState<any>(null);
  const navigate = useNavigate();
  // const { token } = useParams();
  const { token: tokenFromParams } = useParams();
  const token = tokenFromParams || userContext?.token;
  const urlToken = tokenFromParams;
  const isOwner = !urlToken || urlToken === userContext?.localToken;

  interface ParamType {
    pageIndex: number;
    pageSize: number;
    sortBy: string;
    sortDirection: string;
    searchValue: string;
  }

  const parameters: ParamType = {
    pageIndex: 1,
    pageSize: 10,
    sortBy: "",
    sortDirection: "",
    searchValue: "",
  };
  // const token = userContext?.token;
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteStakeId, setDeleteStakeId] = useState<any>(null);
  const [isLoading, setLoading] = useState(false);

  const [addNotesPopup, setAddNotesPopup] = useState<any>({
    open: false,
    stakeId: null,
  });
  const [addStackHolderPopup, setAddStackHolderPopup] = useState<any>({
    open: false,
    stakeId: null,
    uid: null,
  });

  const [historyAndDetailsPopup, setHistoryAndDetailsPopup] = useState<any>({
    open: false,
    stake: null,
  });

  // const handleOpenEditStackHolderPopup = (uid: any) => {
  //   setAddStackHolderPopup({ open: true, uid });
  // };
  const handleOpenEditStackHolderPopup = (uid: any = 0) => {
    if (!uid && totalCount >= 50) {
      // Only block for new stakeholder, not edits
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: "Sorry - 50 stakeholders max!",
        alertType: AlertType.Error,
      });
      return;
    }
    if (totalCount >= 5 && userContext?.userId === 0) {
      navigate("/sign-up");
    } else {
      setAddStackHolderPopup({ open: true, uid });
    }
  };

  const closeAddStakeHolderPopup = async (code?: string) => {
    if (code === "SUBMIT") {
      // await fetchStakList();
      fetchStakList();
    }
    setAddStackHolderPopup({ open: false, uid: null });
  };
  const closeNotesPopup = async (code?: string) => {
    if (code === "SUBMIT") {
      await fetchStakList();
    }
    setAddNotesPopup({ open: false, stakeId: null });
  };

  const handleOpenHistoryAndDetailsPopup = (stake: any) => {
    setHistoryAndDetailsPopup({ open: true, stake });
  };

  const closeHistoryAndDetailsPopup = () => {
    setHistoryAndDetailsPopup({ open: false, stake: null });
    fetchStakList();
  };
  const handleMenuClick = (
    event: React.MouseEvent<HTMLButtonElement>,
    stake: any
  ) => {
    setMenuAnchorEl(event.currentTarget);
    setSelectedStakeholder(stake);
  };

  const handleMenuClose = () => {
    setMenuAnchorEl(null);
    setSelectedStakeholder(null);
  };

  const [stakeList, setStakeList] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState(0);

  const [param, setParam] = useState<ParamType>(parameters);
  const abortControllerRef = useRef<AbortController | null>(null);
  const [isSearchPending, setIsSearchPending] = useState(false);

  const latestSearchValue = useRef("");

  const fetchData = async () => {
    await fetchStakMapDetail();
    await fetchStakList(param.sortBy, param.pageIndex, param.pageSize);
  };

  const fetchStakList = async (
    sortBy: string = "",
    pageIndex: number = 1,
    pageSize: number = 10,
    searchVal: string = "",
    signal?: AbortSignal
  ) => {
    setLoading(true);
    try {
      let response: any;
      let params = new URLSearchParams();
      params.append("token", token || "");
      params.append("SORT_BY", sortBy);
      params.append("pageIndex", pageIndex.toString());
      params.append("pageSize", pageSize.toString());
      params.append("searchValue", searchVal);
      response = await GetStakeList(params, { signal });
      if (response?.data?.data?.stakeColl) {
        setStakeList(response.data?.data?.stakeColl);
        setTotalCount(response.data.data.total_data_count || 0);
      }
    } catch (error: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error.message,
        alertType: AlertType.Error,
      });
    } finally {
      setLoading(false);
    }
  };

  const fetchStakMapDetail = async () => {
    setLoading(true);
    try {
      let response: any;
      let params = new URLSearchParams();
      params.append("token", token || "");
      response = await GetStakemapDetail(params);
      if (response?.data?.data) {
        setTitle(response?.data?.data?.TITLE || "");
      }
    } catch (error: any) {
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error.message,
        alertType: AlertType.Error,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteStake = (UID: any) => {
    setDeleteStakeId(UID);
    setOpenDeleteModal(true);
  };

  const handleConfirmDeleteStake = async () => {
    try {
      await DeleteStake(deleteStakeId);

      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: "Stakeholder deleted successfully.",
        alertType: AlertType.Success,
      });

      setOpenDeleteModal(false);
      setDeleteStakeId(null);

      if (historyAndDetailsPopup.open) closeHistoryAndDetailsPopup();

      fetchStakList();
    } catch (error: any) {
      console.error("Error deleting stakeholder:", error);
      updateUserContext({
        ...userContext,
        isAlert: true,
        alertMessage: error?.message || "Something went wrong!",
        alertType: AlertType.Error,
      });
    }
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
    setDeleteStakeId(null);
  };
  const [value, setValue] = useState("");
  const [page_Index, setPage_Index] = useState(1);
  // Inside ListPage component, before handleLiveSearch
  const debounce = (func: (...args: any[]) => void, wait: number) => {
    let timeout: NodeJS.Timeout;
    return (...args: any[]) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  };

  const handleLiveSearch = (val: string) => {
    setValue(val);
    latestSearchValue.current = val;
    setPage_Index(1);
    setParam((prev: ParamType) => ({
      ...prev,
      searchValue: val,
      pageIndex: 1,
    }));

    // Abort previous request
    if (abortControllerRef.current) abortControllerRef.current.abort();
    const controller = new AbortController();
    abortControllerRef.current = controller;

    setIsSearchPending(true);
    fetchStakListDebounced(val, controller.signal);
  };

  const fetchStakListDebounced = useRef(
    debounce(async (val: string, signal?: AbortSignal) => {
      try {
        await fetchStakList("", 1, param.pageSize, val, signal);
      } catch (err: any) {
        if (err.name !== "AbortError") console.error(err);
      } finally {
        setIsSearchPending(false);
      }
    }, 300)
  ).current;

  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "asc" | "desc";
  }>({
    key: "",
    direction: "asc",
  });

  const handleSort = (key: string) => {
    let direction: "asc" | "desc" = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    fetchStakList(`${key}:${direction}`, param.pageIndex, param.pageSize);
  };

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, [token, param.pageIndex, param.pageSize]);

  return (
    <Box className="listpage-container">
      <ListTopSection
        isLoading={isLoading}
        isOwner={isOwner}
        stakeListLength={stakeList.length}
        value={value}
        onChange={handleLiveSearch}
        onAddClick={() => handleOpenEditStackHolderPopup(0)}
        isSearchPending={isSearchPending}
      />
      <>
        {!isLoading &&
          !isSearchPending &&
          stakeList.length === 0 &&
          value === "" && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                // height: "85vh",
                backgroundColor: "white",
              }}
            >
              <AccountCircleSharpIcon
                sx={{ fontSize: 150, color: "gray", padding: "10px" }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 400,
                  marginBottom: "8px",
                }}
              >
                None added yet
              </Typography>
              {isOwner && (
                // !!userContext?.userId &&
                // <Button
                //   variant="outlined"
                //   className="listpage-add-button"
                //   onClick={handleOpenEditStackHolderPopup}
                // >
                //   <GroupAddIcon sx={{ paddingRight: 1, color: "white" }} />
                //   <span style={{ color: "white" }}> New stakeholder</span>
                // </Button>
                <Button
                  variant="outlined"
                  className="listpage-add-button"
                  // onClick={handleOpenEditStackHolderPopup}
                  onClick={() => handleOpenEditStackHolderPopup(0)}
                  sx={{
                    borderRadius: "4px !important",
                    padding: "6px 10px !important",
                  }}
                >
                  <Box display="flex" alignItems="center" gap="4px">
                    <AddRoundedIcon sx={{ color: "#ffffff" }} />
                    <Typography className="listpage-add-button-text">
                      New stakeholder
                    </Typography>
                  </Box>
                </Button>
              )}
            </Box>
          )}
        <Box sx={{ height: "70vh" }}>
          <TableContainer
            component={Paper}
            sx={{
              // marginBottom: "40px",
              boxShadow: "none",
              padding: "20px 40px 20px 0px",
              height: "100%",
            }}
            className="scroll-hidden"
          >
            <Table
              sx={{
                width: "100%",
                borderCollapse: "collapse",
                tableLayout: "fixed",
                " & td": {
                  // border: "1px solid #E0E0E0",
                  border: "1px solid #E0E0E0",
                  padding: "0px 10px",
                  verticalAlign: "middle",
                  // borderSpacing: "0 4px",
                },
                " & th": {
                  height: "50px !important",
                  padding: "6px 8px 10px 8px ",
                  fontWeight: "600 !important",
                },
              }}
            >
              {stakeList?.length > 0 && (
                <TableHead>
                  <TableRow sx={{ fontSize: "16px" }}>
                    <TableCell
                      sx={{
                        paddingLeft: "0px",
                        width: "2%",
                        borderBottom: "none !important",
                      }}
                    ></TableCell>
                    <TableCell
                      className="table-header"
                      sx={{
                        width: "22%",
                        cursor: "pointer",
                        position: "relative",
                        backgroundColor:
                          sortConfig.key === "name" ? "#f2f1ee" : "transparent", // selected color
                        "&:hover": {
                          backgroundColor: "#f2f1ee", // hover color
                        },
                      }}
                      onClick={() => handleSort("name")}
                    >
                      Stakeholder
                      {sortConfig.key === "name" && (
                        <span
                          style={{
                            position: "absolute",
                            right: 6,
                            top: "50%",
                            transform: `translateY(-50%) rotate(${
                              sortConfig.direction === "asc" ? "0deg" : "180deg"
                            })`,
                            fontSize: "12px",
                          }}
                        >
                          <img src={Arrow} alt="" />
                        </span>
                      )}
                    </TableCell>
                    <TableCell
                      className="table-header"
                      sx={{
                        width: "14%",
                        cursor: "pointer",
                        position: "relative",
                        backgroundColor:
                          sortConfig.key === "company"
                            ? "#f2f1ee"
                            : "transparent", // selected color
                        "&:hover": {
                          backgroundColor: "#f2f1ee", // hover color
                        },
                      }}
                      onClick={() => handleSort("company")}
                    >
                      Company
                      {sortConfig.key === "company" && (
                        <span
                          style={{
                            position: "absolute",
                            right: 6,
                            top: "50%",
                            transform: `translateY(-50%) rotate(${
                              sortConfig.direction === "asc" ? "0deg" : "180deg"
                            })`,
                            fontSize: "12px",
                          }}
                        >
                          <img src={Arrow} alt="" />
                        </span>
                      )}
                    </TableCell>
                    <TableCell
                      className="table-header"
                      sx={{
                        width: "14%",
                        cursor: "pointer",
                        position: "relative",
                        backgroundColor:
                          sortConfig.key === "role" ? "#f2f1ee" : "transparent", // selected color
                        "&:hover": {
                          backgroundColor: "#f2f1ee", // hover color
                        },
                      }}
                      onClick={() => handleSort("role")}
                    >
                      Role
                      {sortConfig.key === "role" && (
                        <span
                          style={{
                            position: "absolute",
                            right: 6,
                            top: "50%",
                            transform: `translateY(-50%) rotate(${
                              sortConfig.direction === "asc" ? "0deg" : "180deg"
                            })`,
                            fontSize: "12px",
                          }}
                        >
                          <img src={Arrow} alt="" />
                        </span>
                      )}
                    </TableCell>
                    <TableCell
                      className="table-header"
                      sx={{
                        width: "13%",
                        cursor: "pointer",
                        position: "relative",
                        backgroundColor:
                          sortConfig.key === "department"
                            ? "#f2f1ee"
                            : "transparent", // selected color
                        "&:hover": {
                          backgroundColor: "#f2f1ee", // hover color
                        },
                      }}
                      onClick={() => handleSort("department")}
                    >
                      Department
                      {sortConfig.key === "department" && (
                        <span
                          style={{
                            position: "absolute",
                            right: 6,
                            top: "50%",
                            transform: `translateY(-50%) rotate(${
                              sortConfig.direction === "asc" ? "0deg" : "180deg"
                            })`,
                            fontSize: "12px",
                          }}
                        >
                          <img src={Arrow} alt="" />
                        </span>
                      )}
                    </TableCell>

                    <TableCell
                      className="table-header"
                      sx={{
                        width: "13%",
                        cursor: "pointer",
                        position: "relative",
                        backgroundColor:
                          sortConfig.key === "temperature"
                            ? "#f2f1ee"
                            : "transparent", // selected color
                        "&:hover": {
                          backgroundColor: "#f2f1ee", // hover color
                        },
                      }}
                      onClick={() => handleSort("temperature")}
                    >
                      Status
                      {sortConfig.key === "temperature" && (
                        <span
                          style={{
                            position: "absolute",
                            right: 6,
                            top: "50%",
                            transform: `translateY(-50%) rotate(${
                              sortConfig.direction === "asc" ? "0deg" : "180deg"
                            })`,
                            fontSize: "12px",
                          }}
                        >
                          <img src={Arrow} alt="" />
                        </span>
                      )}
                    </TableCell>
                    <TableCell
                      className="table-header"
                      sx={{
                        width: "24%",
                        "&:hover": {
                          backgroundColor: "#f2f1ee", // hover color
                        },
                      }}
                    >
                      Latest Notes
                    </TableCell>
                  </TableRow>
                </TableHead>
              )}
              <TableBody>
                {isLoading
                  ? Array.from({ length: 4 }, (_, i) => (
                      <TableRow key={i}>
                        <TableCell
                          sx={{
                            borderTop: "none !important",
                            borderLeft: "none !important",
                            borderBottom: "none !important",
                          }}
                        ></TableCell>
                        <TableCell colSpan={6}>
                          <Skeleton
                            variant="rounded"
                            width="100%"
                            height={25}
                          />
                        </TableCell>
                      </TableRow>
                    ))
                  : stakeList?.length > 0 &&
                    stakeList.map((stake, index) => (
                      <TableRow key={index} className="stakeholder-row">
                        <TableCell
                          sx={{
                            borderTop: "none !important",
                            borderLeft: "none !important",
                            borderRight: "1px solid #E0E0E0 !important",
                            borderBottom: "none !important",
                            padding: "0px 1px 0px  0px !important",
                            textAlign: "right",
                            width: "2%",
                            minWidth: "40px",
                            maxWidth: "50px",
                          }}
                        >
                          <IconButton
                            className="listpage-stakeholder-menu-btn"
                            sx={{
                              padding: 0,
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleMenuClick(e, stake);
                            }}
                          >
                            <img
                              src={moreIcon}
                              alt="edit"
                              style={{
                                width: 16,
                                height: 16,
                                paddingRight: "1px",
                                borderRadius: "4px !importtant",
                              }}
                            />
                          </IconButton>
                        </TableCell>
                        <TableCell
                          className="stakeholder-cell"
                          sx={{ width: "21%" }}
                          onClick={() =>
                            handleOpenHistoryAndDetailsPopup(stake)
                          }
                        >
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            width="100%"
                            height="50px"
                          >
                            <Box
                              display="flex"
                              alignItems="center"
                              gap={1}
                              sx={{ cursor: "pointer" }}
                            >
                              <Box
                                className="stakeholder-color-strip"
                                sx={{
                                  backgroundColor:
                                    stake?.COLOUR_HASH_CODE || "#C8A2C8",
                                }}
                              />
                              <Avatar
                                src={stake?.PROFILE_IMAGE_BASE64 || undefined}
                                className="stakeholder-avatar"
                                sx={{
                                  marginLeft: "15px",
                                  border: "2px solid #E0E0E0",
                                }}
                              >
                                {!stake?.PROFILE_IMAGE_BASE64 && <PersonIcon />}
                              </Avatar>
                              <Box>
                                <Typography
                                  variant="body1"
                                  fontWeight={500}
                                  className="tabel-node-value "
                                  sx={{
                                    maxWidth: {
                                      md: "70px",
                                      lg: "100px",
                                      xl: "180px",
                                    },
                                    display: "flex",
                                    alignItems: "center",
                                    paddingTop: "2px",
                                  }}
                                >
                                  {stake?.FIRST_NAME} {stake?.LAST_NAME}
                                </Typography>
                              </Box>
                            </Box>
                            {isOwner && (
                              // !!userContext?.userId &&
                              <IconButton
                                className="zoom-icon-btn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleMenuClose();
                                  handleOpenEditStackHolderPopup(stake?.UID);
                                }}
                                sx={{
                                  backgroundColor: "transparent",
                                  padding: 0,
                                  "&:hover": { backgroundColor: "transparent" },
                                }}
                              >
                                <img
                                  src={zoomIcon}
                                  alt="edit"
                                  style={{ width: 16, height: 16 }}
                                />
                              </IconButton>
                            )}
                          </Box>
                        </TableCell>
                        {/* <TableCell
                        sx={{ width: "14%" }}
                        className="tabel-listpage-data"
                      >
                        {stake?.ORG_NAME}
                      </TableCell>
                      <TableCell
                        sx={{ width: "14%" }}
                        className="tabel-listpage-data"
                      >
                        {stake?.ROLE_NAME}
                      </TableCell>
                      <TableCell
                        sx={{ width: "13%" }}
                        className="tabel-listpage-data"
                      >
                        {stake?.TEAM_NAME}
                      </TableCell> */}
                        <TableCell
                          sx={{ width: "14%" }}
                          className="tabel-listpage-data"
                        >
                          <CustomTooltip text={stake?.ORG_NAME || ""}>
                            <span
                              style={{
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%", // make it responsive inside container
                              }}
                            >
                              {stake?.ORG_NAME}
                            </span>
                          </CustomTooltip>
                        </TableCell>
                        <TableCell
                          sx={{ width: "14%" }}
                          className="tabel-listpage-data"
                        >
                          <CustomTooltip text={stake?.ROLE_NAME || ""}>
                            <span
                              style={{
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%", // make it responsive inside container
                              }}
                            >
                              {stake?.ROLE_NAME}
                            </span>
                          </CustomTooltip>
                        </TableCell>
                        <TableCell
                          sx={{ width: "13%" }}
                          className="tabel-listpage-data"
                        >
                          <CustomTooltip text={stake?.TEAM_NAME || ""}>
                            <span
                              style={{
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%", // make it responsive inside container
                              }}
                            >
                              {stake?.TEAM_NAME}
                            </span>
                          </CustomTooltip>
                        </TableCell>
                        <TableCell
                          sx={{
                            width: "13%",
                            height: "100%", // let TableCell try to take full row height
                            verticalAlign: "top", // prevent shrinking
                            position: "relative", // allow absolutely positioned child
                          }}
                          className="tabel-data"
                        >
                          <Box
                            sx={{
                              backgroundColor:
                                stake?.notes?.[0]?.temperature
                                  ?.COLOUR_HASH_CODE ||
                                stake?.TEMPERATURE_COLOUR_CODE ||
                                "white",
                              position: "absolute", // fill the TableCell completely
                              top: 4,
                              left: 4,
                              right: 4,
                              bottom: 4,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              borderRadius: "4px",
                              color: "rgba(51, 0, 1, 1)",
                              padding: "0 4px", // optional inner padding
                            }}
                          >
                            {stake?.notes?.[0]?.temperature?.NAME ||
                              (stake?.TEMPERATURE_TYPE
                                ? stake.TEMPERATURE_TYPE.toLowerCase()
                                    .split(" ")
                                    .map(
                                      (word: any) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" ")
                                : "")}
                          </Box>
                        </TableCell>
                        {/* <TableCell
                        sx={{ width: "24%" }}
                        className="tabel-listpage-data"
                      >
                        {stake?.notes?.[0]?.NOTES_TEXT}
                      </TableCell> */}
                        <TableCell
                          sx={{ width: "24%" }}
                          className="tabel-listpage-data"
                        >
                          <CustomTooltip
                            text={stake?.notes?.[0]?.NOTES_TEXT || ""}
                          >
                            <span
                              style={{
                                display: "block",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                maxWidth: "100%", // make it responsive inside container
                              }}
                            >
                              {" "}
                              {stake?.notes?.[0]?.NOTES_TEXT ||
                                stake?.INITIAL_NOTE}
                            </span>
                          </CustomTooltip>
                        </TableCell>
                      </TableRow>
                    ))}
              </TableBody>
            </Table>
          </TableContainer>
          {isLoading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "10px 0px 10px 10px",
              }}
            >
              <Skeleton variant="text" width={"50%"} height={25} />
            </Box>
          ) : (
            stakeList.length > 0 && (
              <Box
                sx={{
                  // position: "absolute",
                  // bottom: 0,
                  // right: 0,
                  width: "100%",
                  background: "white",
                  padding: "8px 40px 30px 20px ",
                  display: "flex",
                  justifyContent: "flex-end",
                }}
              >
                <CustomPagination
                  param={param}
                  setParam={setParam}
                  totalCount={totalCount}
                />
              </Box>
            )
          )}
        </Box>
      </>
      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            borderRadius: "4px",
            minWidth: 180,
            p: 1,
          },
        }}
        MenuListProps={{
          sx: {
            p: 0,
          },
        }}
      >
        <MenuItem
          className="edit-note-menu-item"
          sx={{
            paddingLeft: 0,
            padding: 0,
            height: "28px",
          }}
          onClick={(e) => {
            e.preventDefault();
            handleMenuClose();
            handleOpenHistoryAndDetailsPopup(selectedStakeholder);
          }}
        >
          <ListItemIcon>
            {/* <img
                src={EyeIcon}
                alt="note"
                style={{ width: 25, height: 25, color: "rgba(35, 35, 35, 1)" }}
              /> */}
            <VisibilityOutlinedIcon
              style={{
                width: 18,
                height: 18,
                marginLeft: "5px",
                color: "rgba(35, 35, 35, 1)",
              }}
            />
          </ListItemIcon>
          <ListItemText
            primary="Details"
            className="popup-text"
            style={{ color: "rgba(35, 35, 35, 1)" }}
          />
        </MenuItem>

        {isOwner && (
          // !!userContext?.userId &&
          <MenuItem
            className="edit-note-menu-item"
            sx={{
              paddingLeft: 0,
              padding: 0,
              height: "28px",
            }}
            onClick={(e) => {
              e.preventDefault();
              handleMenuClose();
              handleOpenEditStackHolderPopup(selectedStakeholder?.UID);
            }}
          >
            <ListItemIcon>
              <img
                src={EditStakeIcon}
                alt="note"
                style={{
                  width: 25,
                  height: 25,
                  color: "rgba(35, 35, 35, 1)",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Edit"
              className="popup-text"
              style={{ color: "rgba(35, 35, 35, 1)" }}
            />
          </MenuItem>
        )}

        {/* <MenuItem
            className="edit-note-menu-item"
            sx={{
              paddingLeft: 0,
              padding: "3px 0px 3px 0px",
            }}
          >
            <ListItemIcon>
              <img
                src={DuplicateIcon}
                alt="Duplicate"
                style={{
                  width: 18,
                  height: 14,
                  color: "rgba(35, 35, 35, 1)",
                  paddingLeft: "5px",
                }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Duplicate"
              className="popup-text"
              style={{ color: "rgba(35, 35, 35, 1)" }}
            />
          </MenuItem> */}
        {isOwner && (
          // !!userContext?.userId &&
          <MenuItem
            className="delete-note-menu-item"
            sx={{
              paddingLeft: 0,
              paddingTop: 0,
              paddingBottom: 0,
              paddingRight: 0,
              height: "28px",
            }}
            onClick={(e) => {
              e.preventDefault();
              handleMenuClose();
              handleDeleteStake(selectedStakeholder?.UID);
            }}
            disableRipple
          >
            <ListItemIcon className="delete-list-item-icon">
              <img
                src={DeleteIcon}
                alt="delete"
                style={{ paddingLeft: "5px" }}
              />
            </ListItemIcon>
            <ListItemText
              primary="Delete"
              className="delete-text"
              style={{ color: "rgba(104, 0, 1, 1)" }}
            />
          </MenuItem>
        )}
      </Menu>
      <Dialog
        open={historyAndDetailsPopup.open}
        onClose={closeHistoryAndDetailsPopup}
        fullWidth={false}
        maxWidth={false}
        PaperProps={{
          sx: {
            // padding: "30px",
            margin: 0,
            width: "1100px",
          },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            alignItems: "center",
            padding: "30px 30px 16px 30px ",
          }}
        >
          <Avatar sx={{ mr: 2 }}>
            <img
              src={editProfileIcon}
              alt="Edit profile"
              style={{ width: "42px", height: "42px" }}
            />
          </Avatar>
          <Typography className="edit-popup-title">
            Stakeholder Details
          </Typography>
          <IconButton
            onClick={closeHistoryAndDetailsPopup}
            sx={{
              ml: "auto",
              padding: "0 !important",
              backgroundColor: "transparent !important",
              "&:hover": {
                backgroundColor: "transparent !important",
              },
            }}
          >
            <img
              src={CloseIcon}
              alt="Close"
              style={{ width: 24, height: 24 }}
            />
          </IconButton>
        </DialogTitle>
        <Divider sx={{ mx: 4 }} />
        <DialogContent
          // dividers
          sx={{
            px: 3,
            py: 2,
            padding: "10px 0px 0px 0px",
            borderBottom: "none",
          }}
        >
          <StakeHoldersDetail
            stackholder={historyAndDetailsPopup.stake}
            handleDeleteStack={(UID: string) => {
              handleDeleteStake(UID);
            }}
          />
        </DialogContent>
      </Dialog>

      <AddNoteDialog
        UID={0}
        STAKEUID={addNotesPopup?.stakeId || ""}
        open={addNotesPopup.open}
        onClose={closeNotesPopup}
      />
      <AddStakeHolderDialog
        open={addStackHolderPopup.open}
        // onClose={closeAddStakeHolderPopup}
        onClose={(CODE, UID) => {
          closeAddStakeHolderPopup(CODE);
          if (CODE === "OPEN_NOTES") {
            setAddNotesPopup({ open: true, stakeId: UID });
          }
        }}
        UID={addStackHolderPopup?.uid || 0}
        title={title}
      />

      <Dialog
        open={openDeleteModal}
        onClose={handleCloseDeleteModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        TransitionComponent={undefined} // removes transition
        BackdropProps={{ transitionDuration: 0 }}
      >
        <DialogContent>
          <Typography id="alert-dialog-description">
            Are you sure you want to delete this stakeholder?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleConfirmDeleteStake}
            variant="contained"
            color="error"
            sx={{ backgroundColor: "#4C0808" }}
            disableRipple
            disableFocusRipple
          >
            Yes, Delete
          </Button>
          <Button
            onClick={handleCloseDeleteModal}
            variant="outlined"
            sx={{ backgroundColor: "#ffffff" }}
            disableRipple
            disableFocusRipple
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ListPage;
